import { MLHelper } from '@bimser/core';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { IControlProperties } from '../../../../../entities';
import { IDataGridColumn } from '../entities';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);

export function timePickerFormatter(this: IDataGridColumn<IControlProperties>, value: Date) {
	return dayjs(value)
		.locale(MLHelper.currentLanguage.culture)
		.format(this.format || 'HH:mm');
}

export function datePickerFormatter(this: IDataGridColumn<IControlProperties>, value: Date) {
	return dayjs(value)
		.locale(MLHelper.currentLanguage.culture)
		.format(
			this.format ||
				dayjs().locale(MLHelper.currentLanguage.culture).localeData().longDateFormat('L')
		);
}

export function dateTimePickerFormatter(this: IDataGridColumn<IControlProperties>, value: Date) {
	return dayjs(value)
		.locale(MLHelper.currentLanguage.culture)
		.format(
			this.format ||
				`${dayjs()
					.locale(MLHelper.currentLanguage.culture)
					.localeData()
					.longDateFormat('L')} ${dayjs()
					.locale(MLHelper.currentLanguage.culture)
					.localeData()
					.longDateFormat('LT')}`
		);
}

export function dateRangePickerFormatter(this: IDataGridColumn<IControlProperties>, value: Date[]) {
	return value
		.map(date => dayjs(date))
		.filter(date => date.isValid())
		.map(date =>
			date
				.locale(MLHelper.currentLanguage.culture)
				.format(
					this.format ||
						dayjs()
							.locale(MLHelper.currentLanguage.culture)
							.localeData()
							.longDateFormat('L')
				)
		)
		.join(' / ');
}
